import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ApiUrl } from "Services/Services";

function DealView() {
  const [deal, setDeal] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const res = await axios.get(`${ApiUrl}/deals/${id}`);
        setDeal(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchDeal();
  }, [id]);

  if (!deal) {
    return <div className="text-center mt-10 text-gray-500 text-lg">Loading...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 mt-6">
      {/* Deal Card */}
      <div className="bg-white rounded-xl shadow-md p-6 flex flex-col md:flex-row items-center gap-6">
        <img
          src={deal.image}
          alt={deal.name}
          className="w-64 h-64 object-cover rounded-lg border border-gray-200"
        />
        <div className="flex-1">
          <h2 className="text-3xl font-bold text-gray-800">{deal.name}</h2>
          <p className="text-gray-600 mt-2">{deal.description}</p>
          <p className="text-xl font-semibold mt-3 text-yellow-600">
            Price: ${deal.price}
          </p>
          <p className="mt-2">
            Status:{" "}
            <span
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                deal.status === "active"
                  ? "bg-green-100 text-green-800"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              {deal.status}
            </span>
          </p>
        </div>
      </div>

      {/* Foods in Deal */}
      <div className="mt-8">
        <h3 className="text-2xl font-semibold mb-4 text-gray-700">Included Foods</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {deal.foods.map((food) => {
            // find selected variation if exists
            const selectedVariation = food.variations.find(
              (v) => v.id === food.DealItem.variationId
            );

            const displayName = selectedVariation
              ? `${food.name} (${selectedVariation.name})`
              : food.name;

            const displayPrice = selectedVariation
              ? selectedVariation.price
              : food.price;

            return (
              <div
                key={food.id}
                className="flex items-center gap-4 p-4 bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
              >
                <div className="relative">
                  <img
                    src={food.image}
                    alt={food.name}
                    className="w-24 h-24 object-cover rounded-lg border border-gray-200"
                  />
                  <span className="absolute top-0 right-0 bg-yellow-400 text-white text-xs font-semibold px-2 py-1 rounded-full">
                    x{food.DealItem.quantity}
                  </span>
                </div>
                <div className="flex-1">
                  <p className="font-medium text-gray-800">{displayName}</p>
                  <p className="text-gray-500 text-sm mt-1">
                    ${displayPrice.toLocaleString()}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DealView;
